import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const COMPANY_HIERARCHY_SIDENAV_LINKS = new InjectionToken<void>("COMPANY_HIERARCHY_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "CompanyHierarchy",
        icon: "company",
        label: "SETTINGS.ITEMS.COMPANY_HIERARCHY",
        expanded: true,
        items: [
          {
            id: "Directories",
            label: "SETTINGS.ITEMS.DIRECTORIES",
            routerLink: "/settings/directories",
            permissions: COMMON_GUARD_OPTIONS.DIRECTORY.VIEW.permissions,
          },
          {
            id: "Countries",
            label: "SETTINGS.ITEMS.COUNTRIES",
            routerLink: "/settings/countries",
            permissions: COMMON_GUARD_OPTIONS.COUNTRY.VIEW.permissions,
          },
          {
            id: "Lands",
            label: "SETTINGS.ITEMS.LANDS",
            routerLink: "/settings/lands",
            permissions: COMMON_GUARD_OPTIONS.LAND.VIEW.permissions,
          },
          {
            id: "Areas",
            label: "SETTINGS.ITEMS.AREAS",
            routerLink: "/settings/areas",
            permissions: COMMON_GUARD_OPTIONS.AREA.VIEW.permissions,
          },
          {
            id: "MicroAreas",
            label: "SETTINGS.ITEMS.MICRO_AREAS",
            routerLink: "/settings/micro-areas",
            permissions: COMMON_GUARD_OPTIONS.MICRO_AREA.VIEW.permissions,
          },
          {
            id: "Locations",
            label: "SETTINGS.ITEMS.LOCATIONS",
            routerLink: "/settings/locations",
            permissions: COMMON_GUARD_OPTIONS.LOCATION.VIEW.permissions,
          },
          {
            id: "Affiliates",
            label: "SETTINGS.ITEMS.AFFILIATES",
            routerLink: "/settings/affiliates",
            permissions: COMMON_GUARD_OPTIONS.AFFILIATE.VIEW.permissions,
          },
          {
            id: "Desks",
            label: "SETTINGS.ITEMS.DESKS",
            routerLink: "/settings/desks",
            permissions: COMMON_GUARD_OPTIONS.DESK.VIEW.permissions,
          },
          {
            id: "Configurations",
            label: "SETTINGS.ITEMS.CONFIGURATIONS",
            expanded: true,
            icon: "configuration",
            items: [
              {
                id: "LocationPlacement",
                label: "SETTINGS.ITEMS.LOCATION_PLACEMENTS",
                routerLink: "/settings/location-placements",
                permissions: COMMON_GUARD_OPTIONS.LOCATION_PLACEMENT.VIEW.permissions,
              },
            ],
          },
        ],
      },
    ]);
  },
});
